import React, { useState } from "react";
import ModalComponent from "../../../components/modal";
import CreateTruck from "./createTruck";
import ToastMessage from "../../../components/toastMessage";

function CreateTruckModal({
    showTruckModal,
    handleCloseTruckModal,
    setIsTruckDataChange,
    setShowTruckModal,
}) {
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [plateNumber, setPlateNumber] = useState(null);

    const onSuccess = (plateNumber) => {
        setPlateNumber(plateNumber);
        setShowSuccessMessage(true);
        setShowTruckModal(false);
    };
    return (
        <>
            <ModalComponent
                open={showTruckModal}
                size="large"
                borderedHeader
                onClose={handleCloseTruckModal}
                header="New Truck"
            >
                <CreateTruck
                    onClose={handleCloseTruckModal}
                    onSuccess={onSuccess}
                    setIsTruckDataChange={setIsTruckDataChange}
                />
            </ModalComponent>
            {showSuccessMessage && (
                <ToastMessage
                    type="success"
                    showToast={showSuccessMessage}
                    setShowToast={setShowSuccessMessage}
                    name={plateNumber}
                    text="has been created successfully and is pending
                    verification."
                />
            )}
        </>
    );
}

export default CreateTruckModal;
